import TerminateSocialSecurityReportComponent from "features/Report/components/employeeHistoryGroup/TerminateSocialSecurityReport";
import useTerminateSocialSecurity from "features/Report/hooks/employeeHistoryGroup/useTerminateSocialSecurity";

const TerminateSocialSecurityReportPage = () => {
    const useTerminateSocialSecurityProps = useTerminateSocialSecurity();
    return <TerminateSocialSecurityReportComponent {...useTerminateSocialSecurityProps} />
}

export default TerminateSocialSecurityReportPage;